const VALID_CODES = [
  "invalidEmail",
  "maxEquity",
  "invalidCountry",
  "invalidPropertyType",
  "invalidMarketingType",
] as const;

export type ValidationErrorCode = (typeof VALID_CODES)[number];

export const isErrorCode = (code: unknown): code is ValidationErrorCode => {
  return (
    typeof code === "string" &&
    (VALID_CODES as readonly string[]).includes(code)
  );
};

export type ValidationApiError = Error & {
  cause: {
    status: number;
    code: ValidationErrorCode;
    fieldPath: string;
  };
};

export const isValidationError = (error: unknown): error is ValidationApiError => {
  return (
    error instanceof Error &&
    "cause" in error &&
    error.cause !== null &&
    typeof error.cause === "object" &&
    "status" in error.cause &&
    (error.cause as { status: number }).status === 422 &&
    "code" in error.cause &&
    isErrorCode((error.cause as { code: unknown }).code) &&
    "fieldPath" in error.cause
  );
};
